import axios from "axios";

const API_URL = "https://lukkypro.ru/api/v1/";

export type SpreadMoverDirection = "UP" | "DOWN" | "RANDOM";

export interface SpreadMoverSettingsData {
    connection_id: string;
    is_active: boolean;
    check_time_min: number;
    check_time_max: number;
    shift_min: string;
    shift_max: string;
    min_spread_move: string;
    max_spread_move: string;
    min_spread: string;
    max_spread: string;
    order_amount_min: string;
    order_amount_max: string;
    min_step_price: string;
    max_step_price: string;
    direction_mode: SpreadMoverDirection;
    next_move_at: string | null;
    last_move_at: string | null;
}

export type EditSpreadMoverPayload = Omit<
    SpreadMoverSettingsData,
    "connection_id" | "next_move_at" | "last_move_at"
>;

const authHeaders = () => ({
    Authorization: `Bearer ${localStorage.getItem("authToken")}`,
});

export const getSpreadMover = async (connectionId: string) => {
    const { data } = await axios.get<SpreadMoverSettingsData>(
        `${API_URL}spread_movers/${connectionId}`,
        { headers: authHeaders() }
    );
    return data;
};

export const saveSpreadMover = async (
    connectionId: string,
    payload: EditSpreadMoverPayload
) => {
    const { data } = await axios.post<SpreadMoverSettingsData>(
        `${API_URL}spread_movers/${connectionId}/edit`,
        payload,
        { headers: authHeaders() }
    );
    return data;
};
